import { render, staticRenderFns } from "./DashEmergentesProjetosView.vue?vue&type=template&id=a9e04bf0&"
import script from "./DashEmergentesProjetosView.vue?vue&type=script&lang=ts&"
export * from "./DashEmergentesProjetosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports